export default __webpack_public_path__ + "static/media/guide13.30676a98.png";